import forEach from "lodash/forEach";

export const UpdateInnerHtml = (html, attr = {}) => {
  const e = document.createElement("div");
  e.innerHTML = html;
  forEach(attr, (value, attribute) => {
    e.firstElementChild?.setAttribute(attribute, value);
  });
  return e.innerHTML;
};
